"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "How do I get started with your services?",
    answer: "Getting started is simple. First, review our service packages to find the one that best fits your needs. Then, click the 'Get Started' button to fill out our intake form. Once we receive your details, a member of our team will reach out to schedule a consultation and guide you through the next steps."
  }, {
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards, including Visa, MasterCard, and American Express. For enterprise clients, we also offer invoicing and bank transfer options. All payments are processed securely through our encrypted payment gateway to ensure your financial information remains protected."
  }, {
    question: "Can I cancel or change my subscription?",
    answer: "Yes, flexibility is key to our service. You can upgrade, downgrade, or cancel your subscription at any time from your account dashboard. Changes to your plan will take effect at the start of the next billing cycle, while cancellations will remain active until the end of the current period."
  }, {
    question: "Do you offer customer support outside of business hours?",
    answer: "Our dedicated support team is available 24/7 to assist you with any urgent issues. For general inquiries, our standard business hours are Monday through Friday, 9 AM to 6 PM. You can reach us via email, live chat, or our toll-free support line."
  }, {
    question: "Is my data secure with your platform?",
    answer: "Security is our top priority. We utilize industry-standard encryption protocols and regular security audits to safeguard your data. Our platform is fully compliant with GDPR and other major privacy regulations, ensuring that your information is handled with the utmost care and confidentiality."
  }];
  return <section id="frequently-asked-questions" ref={ref} className={`bg-background py-20 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="mx-auto max-w-[1280px] px-6 md:px-12 lg:px-24">
        <div className="mb-12 text-center">
          <h2 className="inline-block border-b-2 border-[color:var(--ring)] pb-2 font-serif text-4xl font-bold text-primary md:text-5xl">
            Common Inquiries
          </h2>
        </div>

        <div className="mx-auto max-w-4xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border border-b" data-index={i}>
                <AccordionTrigger className="group py-6 hover:no-underline [&>svg:last-child]:hidden">
                  <div className="flex w-full items-center justify-between pr-2">
                    <span className="text-left font-serif text-xl font-bold text-foreground">
                      {faq.question}
                    </span>
                    <Plus className="size-6 shrink-0 text-[color:var(--ring)] transition-transform duration-400 group-data-[state=open]:rotate-45" />
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-foreground/80 font-sans text-lg leading-[1.6] [animation-duration:0.4s] [animation-timing-function:ease-in-out]">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}